import axios from 'axios';

export const FLAG_API = `${process.env.REACT_APP_BACKEND_URL}/api/caseload-review`;
export const FLAG_MANAGEMENT_ROLES = ['system_admin', 'executive', 'operations_manager', 'supervisor', 'case_manager_supervisor'];
export const FLAG_UPDATED_EVENT = 'myhelp:caseload-flag-updated';

export const FLAG_STATUS_STYLES = {
  Flagged: 'bg-red-100 text-red-700 border-red-300',
  'In Progress': 'bg-amber-100 text-amber-700 border-amber-300',
  'Pending Management Review': 'bg-blue-100 text-blue-700 border-blue-300',
  'Returned for Correction': 'bg-orange-100 text-orange-700 border-orange-300',
  Resolved: 'bg-green-100 text-green-700 border-green-300',
};

export const ticketPath = (flagId) => `/caseload-review/tickets/${flagId}`;
export const notifyFlagUpdated = () => window.dispatchEvent(new Event(FLAG_UPDATED_EVENT));

export const flagApi = {
  all: (params) => axios.get(`${FLAG_API}/flags/all`, { params }).then((r) => r.data),
  mine: () => axios.get(`${FLAG_API}/flags/mine`).then((r) => r.data.flags),
  forHeader: (headerId) => axios.get(`${FLAG_API}/flags`, { params: { header_id: headerId } }).then((r) => r.data.flags),
  detail: (id) => axios.get(`${FLAG_API}/flags/${id}`).then((r) => r.data),
  create: (recordId, comments, flagFor = 'case_manager') => axios.post(`${FLAG_API}/records/${recordId}/flag`, { comments, flag_for: flagFor }).then((r) => r.data),
  targets: (recordId) => axios.get(`${FLAG_API}/records/${recordId}/flag-targets`).then((r) => r.data),
  submit: (id, note) => axios.post(`${FLAG_API}/flags/${id}/submit`, { note }).then((r) => r.data),
  awaiting: () => axios.get(`${FLAG_API}/flags/awaiting-my-review`).then((r) => r.data.flags),
  followUp: (id) => axios.post(`${FLAG_API}/flags/${id}/follow-up-summary`).then((r) => r.data),
  approve: (id, note) => axios.post(`${FLAG_API}/flags/${id}/approve`, { note }).then((r) => r.data),
  returnFlag: (id, comment) => axios.post(`${FLAG_API}/flags/${id}/return`, { comment }).then((r) => r.data),
  draftField: (id, field, value) => axios.put(`${FLAG_API}/flags/${id}/draft`, { field, value: field === 'barriers' ? value.split(',').map((b) => b.trim()).filter(Boolean) : value }).then((r) => r.data),
  draftNote: (id, noteId, content) => axios.put(`${FLAG_API}/flags/${id}/draft-note`, { note_id: noteId, content }).then((r) => r.data),
  editNote: (noteId, content) => axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/case-notes/${noteId}`, { content }),
  comment: (id, note) => axios.post(`${FLAG_API}/flags/${id}/comments`, { note }).then((r) => r.data),
  saveField: (recordId, field, value) => {
    if (field === 'state_id_number') return axios.put(`${FLAG_API}/records/${recordId}/state-id`, { state_id_number: value });
    if (['abawd_status', 'certification_start_date', 'certification_end_date', 'employment_goal', 'barriers'].includes(field)) {
      const v = field === 'barriers' ? value.split(',').map((b) => b.trim()).filter(Boolean) : value;
      return axios.put(`${FLAG_API}/records/${recordId}/targeted-outcomes`, { [field]: v });
    }
    return axios.put(`${FLAG_API}/records/${recordId}`, { [field]: value });
  },
};

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' }) : '');
